import Label from "minimals-template/components/Label"

export function ScheduleLabel({ label, code }) {
    return (
        <>
            {label} <Label sx={{ bgcolor: "transparent", px: 0, height: "auto", lineHeight: "inherit" }}>#{code}</Label>
        </>
    )
}
